import CustomDivider from "@/components/custom-divider/CustomDivider"
import { SvgIcon } from "@/components/icon"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import { FC } from "react"

const { Title, Paragraph } = WebsiteTypography

const AutoApprovalTriggered: FC = () => {
  return (
    <Row justify={"center"}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Row justify={"center"} style={{ paddingBottom: 24 }}>
          <SvgIcon type={"circled-tick"} color={"green"} />
        </Row>

        <Title level={3} centered className={"form-section-title"}>
          <span className={"w300"}>{"Auto Approvals "}</span>
          <span className={"bold"}>{"Triggered Successfully"}</span>
        </Title>

        <Paragraph centered size={"md"} style={{ paddingTop: 24 }} color={"website-secondary"}>
          {
            "The Auto Approval process has been executed successfully. You may remain on this panel to confirm that the selected items have been removed and, where applicable, replaced with newly available items."
          }
        </Paragraph>
        <CustomDivider marginBottom={0} color={"light-gray"} />
        <Paragraph centered size={"sm"} style={{ paddingTop: 8 }} color={"website-secondary"}>
          {
            'After closing Approval Review panel click the "Refresh Table Data" button to get updated information if needed.'
          }
        </Paragraph>
      </Col>
    </Row>
  )
}

export default AutoApprovalTriggered
